import { createSelector } from 'reselect'
import omit from 'lodash/omit'
import { RootState } from '../../../store'
import { ProgramItem, ProgramSpace } from '../types'
import { isSameDay, toDate } from '../../../utils/datetime'

const minutesPerDay = 60 * 24
export const mapGetDayWidthToProps = (state: RootState) => ({
    dayWidth: state.timetable.zoomLevel.widthPerMinute * minutesPerDay,
})

export const getProgramSpacesForDate = createSelector(
    [
        (state: RootState) => state.timetable.spaces.data,
        (state: RootState) => state.timetable.date,
    ],
    (spaces, date): ProgramSpace[] => {
        const dateFilter = (item: ProgramItem) => isSameDay(toDate(item.start_date), date)
                || isSameDay(toDate(item.end_date), date)

        if (!spaces) {
            return []
        }

        return spaces
            // Filter for date in spaces
            .map((space) => ({
                ...space,
                items: space.items.filter(dateFilter),
            }))
            // Remove spaces without items
            .filter((space) => space.items.length)
            // add space props to items
            .map((space): ProgramSpace => ({
                ...space,
                items: space.items.map((item) => ({ ...item, space: omit(space, 'items') })),
            }))
    },
)
